import { createFileRoute } from '@tanstack/react-router';
import { PeopleWelcomeRouteView } from '@/pages/workspaces/people/routing';
import { LastWorkspaceResolver } from './-components';

/**
 * No `appBundle`: this URL has no `journeys` segment, and the bundle-aware
 * branch of the resolver rebuilds the target from the bundle prefix — which
 * would find no `/journeys/` here and land on the Journeys home instead.
 */
function ProfilesWelcomeRoute() {
  return (
    <LastWorkspaceResolver>
      <PeopleWelcomeRouteView />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/profiles/welcome')({
  component: ProfilesWelcomeRoute,
});
